import React from 'react';
// import React, { useState } from 'react';
// import * as _ from 'lodash';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
// import IconButton from '@material-ui/core/IconButton';
// import PlayCircleFilledIcon from '@material-ui/icons/PlayCircleFilled';

const FOLLOWUP_HISTORY_HEADERS = [
  { label: 'Attempt Number', key: 'attempt_number' },
  { label: 'Agent Type', key: 'agent_type' },
  { label: 'Followup Type', key: 'followup_type' },
  { label: 'Followup Status', key: 'status_label' },
  { label: 'Attempt Date', key: 'invoked_at' },
  // TODO: enable call recording playback later
  // { label: 'Call Recording', key: 'recording_url' },
];

// TODO: enable call recording playback later
// const CallRecordingCell = ({ recordingUrl }) => {
//   const [isPlaying, setIsPlaying] = useState(false);
//
//   if (_.isEmpty(recordingUrl)) {
//     return <TableCell />;
//   }
//
//   return (
//     <TableCell>
//       {isPlaying ? (
//         <audio
//           src={recordingUrl}
//           controls
//           autoPlay
//           style={{ height: 32, verticalAlign: 'middle' }}
//         >
//           <track kind="captions" />
//         </audio>
//       ) : (
//         <IconButton
//           size="small"
//           color="secondary"
//           title="Play call recording"
//           onClick={() => setIsPlaying(true)}
//         >
//           <PlayCircleFilledIcon />
//         </IconButton>
//       )}
//     </TableCell>
//   );
// };

const FollowupHistoryTable = ({ followups }) => (
  <Table size="small">
    <TableHead>
      <TableRow>
        {FOLLOWUP_HISTORY_HEADERS.map((header) => (
          <TableCell key={header.key}>{header.label}</TableCell>
        ))}
      </TableRow>
    </TableHead>
    <TableBody>
      {(followups || []).length ? (
        followups.map((followup) => (
          <TableRow key={`${followup.attempt_number}-${followup.scheduled_at}`}>
            <TableCell>{followup.attempt_number}</TableCell>
            <TableCell>{followup.agent_type}</TableCell>
            <TableCell>{followup.followup_type}</TableCell>
            <TableCell>{followup.status_label}</TableCell>
            <TableCell>
              {followup.status_label === 'Call queued'
                ? followup.scheduled_at
                : followup.invoked_at}
            </TableCell>
            {/* TODO: enable call recording playback later */}
            {/* <CallRecordingCell recordingUrl={followup.recording_url} /> */}
          </TableRow>
        ))
      ) : (
        <TableRow>
          <TableCell colSpan={FOLLOWUP_HISTORY_HEADERS.length} align="center">
            No followup history available.
          </TableCell>
        </TableRow>
      )}
    </TableBody>
  </Table>
);

export default FollowupHistoryTable;
